import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;

    div.Container__qtd {
        width: 30px;
        height: 30px;
        background: #fff;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 700;
    }

    button.Container__main_bar {
            /* width: 100%; */
            height: 30px;
            min-height: 30px;
            background: #5DA57D;
            border-radius: 4px;
            border: none;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 5px 0px;
            cursor: pointer;

            :hover {
                filter: brightness(95%);
            }

            span.Container__main_bar__item__name {
                font-weight: 700;
                font-size: 13px;
                color: #fff;
                text-align: left;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                text-transform: capitalize;
            }
            
            span.Container__main_bar__item__size {
                background: #fff;
                height: 20px;
                border-radius: 3px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 0;
                padding: 0;
                font-weight: 700;
                font-size: 13px;
                padding: 5px;
                color: var(--primary-color);
                white-space: nowrap;
                font-feature-settings: "tnum"
            }
        }
`